<template>
    <div class="testLeads" v-can="'check_lead.access'">
        <FieldFilter @refresh="refreshFilter">
            <form @submit.prevent="searchData">
                <vs-row vs-w="12" class="items-center">
                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2">
                            <vs-input
                                :label-placeholder="$t('modals.Phone')"
                                v-model="leadData.phone"
                                :disabled="!!leadData.email"
                                class="w-full"
                            />
                        </div>
                    </vs-col>
                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2">
                            <vs-input
                                :label-placeholder="$t('global.Email')"
                                v-model="leadData.email"
                                :disabled="!!leadData.phone"
                                class="w-full"
                            />
                        </div>
                    </vs-col>
                    <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                        <div class="p-2">
                            <vs-checkbox v-model="todayCheck">{{$t('global.today')}}</vs-checkbox>
                        </div>
                    </vs-col>
                </vs-row>

                <div class="mt-5">
                    <vs-button
                        :disabled="!(leadData.phone.length || leadData.email.length)"
                        @click="clear()"
                    >{{$t('buttons.Clear')}}</vs-button>
                    <vs-button
                        :disabled="!(leadData.phone.length || leadData.email.length) || btnDisabled"
                        class="ml-4"
                        button="submit"
                    >{{$t('buttons.Search')}}</vs-button>
                </div>
            </form>
        </FieldFilter>

        <ds-table
            v-if="table.data.length"
            :data="table.data"
            :heads="table.headers"
            :paginate="false"
            :max-items="table.data.length"
            class="tableLeads"
        >
            <template v-slot:person="{person}">
                <div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-user', 'fi-rr-user')"></vs-icon>
                        {{ person.first_name ? person.first_name : '-' }} {{ person.last_name ? person.last_name : '-' }}
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-mail', 'fi-rr-envelope')"></vs-icon>
                        {{ person.email ? person.email : '-' }}
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-smartphone', 'fi-rr-mobile-notch')"></vs-icon>
                        {{ person.phone ? person.phone : '-' }}
                    </div>

                    <div class=" font-medium truncate flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-map-pin', 'fi-rr-marker')"/>
                        {{ person.ip ? person.ip : '-' }}
                    </div>
                </div>
            </template>

            <template v-slot:country="{country}">
                <div v-if="country.country && country.country !== undefined && country.country !== 'undefined'"
                     class="flex items-center">
                    <flag width="25" :iso="country.country" type="country"/>
                    <span class="pl-2">{{ country.country }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:language="{language}">
                <div v-if="language.language && language.language !== undefined && language.language !== 'undefined'"
                     class="flex items-center">
                    <flag width="25" :iso="language.language" type="language"/>
                    <span class="pl-2">{{ language.language }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:landing="{landing}">
                <v-text v-if="landing.landing_url" :text="landing.landing_url"></v-text>

                <div v-else>-</div>
            </template>

            <template v-slot:advertiser="{advertiser}">
                <div>{{advertiser.advertiser || advertiser.advertiser_id || '-'}}</div>
            </template>

            <template v-slot:geo="{geo}">
                <div v-if="geo.geo && geo.language !== undefined && geo.geo !== 'undefined'" class="flex items-center">
                    <img style="width: 25px" :src="getGeoFlag(geo.geo).flag" alt="">
                    <span class="pl-2 whitespace-no-wrap">{{ geo.geo }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:affiliate="{affiliate}">
                <div v-if="!affiliate.affiliate_name">-</div>
                <div v-else>{{affiliate.affiliate_name}}</div>
            </template>

            <template v-slot:campaign_id="{campaign_id}">
                <div>
                    <p class="font-medium" >{{ campaign_id.campaign ? campaign_id.campaign.name : '-' }}</p>
                    <div class="flex">
                        <p class="whitespace-no-wrap text-xs camp-ident">{{ campaign_id.campaign_identifier ? campaign_id.campaign_identifier : '-' }}</p>
                        <vs-icon v-if="campaign_id.campaign_identifier" @click="copyText(campaign_id.campaign_identifier)" v-tooltip="$t('tooltip.Copy')" color="primary" class="ml-1 cursor-pointer" v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')" />
                    </div>
                </div>
            </template>

            <template v-slot:status="{status}">
                <div v-if="!status.status">-</div>
                <vs-chip v-else transparent :color="sysStatus(status.status)">
                    {{ strUpp(status.status) }}
                </vs-chip>
            </template>

            <template v-slot:errorStatus="{errorStatus}">
                <div class="flex flex-col" v-if="errorStatus.errors_validation && checkArray(errorStatus.errors_validation)">
                    <div v-for="(error, index) of checkArray(errorStatus.errors_validation)"
                       :key="index"
                       class="whitespace-no-wrap"
                    >
                        {{error}}
                    </div>
                </div>
                <div class="flex flex-col" v-else-if="errorStatus.errors_validation && checkObject(errorStatus.errors_validation)">
                    <div v-for="(error, name) of checkObject(errorStatus.errors_validation)"
                       :key="name"
                       class="whitespace-no-wrap"
                    >
                        {{name}} - {{error}}
                    </div>
                </div>
                <p v-else>-</p>
            </template>

            <template v-slot:token="{token}">
                <div>{{ token.token ? token.token : '-' }}</div>
            </template>

            <template v-slot:params_url="{params_url}">
                <div>{{ params_url.url_params ? params_url.url_params : '-' }}</div>
            </template>

            <template v-slot:created_at="{created_at}">
                <div v-if="!created_at.created_at">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-days')"></vs-icon>
                        <span v-if="created_at.created_at">{{ _date(created_at.created_at).date() }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="created_at.created_at">{{ _date(created_at.created_at).time() }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:send_date="{send_date}">
                <div v-if="!send_date.send_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-days')"></vs-icon>
                        <span v-if="send_date.send_date">{{ _date(send_date.send_date).date() }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="send_date.send_date">{{ _date(send_date.send_date).time() }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:a_history="{a_history}">
                <div v-if="a_history.advertisers_history">
                    <div class="flex items-center" v-if="value" v-for="(value, key) in a_history.advertisers_history"
                         :key="key">
                        <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                        <div class="whitespace-no-wrap ml-2">{{ value }}</div>
                    </div>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:adv_history_response="{adv_history_response}">
                <div v-if="adv_history_response.advertiser_history_response && Array.isArray(adv_history_response.advertiser_history_response)" class="flex items-center" v-for="(adv_res, index) of adv_history_response.advertiser_history_response" :key="index">
                    <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                    <div>
                        <div class="whitespace-no-wrap ml-2 textOverflow statusErrorsText">{{ adv_res.answer }}</div>
                    </div>
                    <vs-icon
                        class="ml-2 cursor-pointer"
                        color="primary"
                        v-tooltip="$t('tooltip.Copy')"
                        @click.stop.prevent="copy(adv_res.answer)"
                        v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                    />
                    <vs-icon
                        v-if="adv_res.answer && adv_res.answer.length >= 35"
                        class="ml-2 cursor-pointer"
                        color="primary"
                        @click.stop.prevent="errorStatusInfo(adv_res.answer)"
                        v-bind="$iconData('icon-eye', 'fi-rr-eye')"
                    />
                </div>
                <div v-else>-</div>
            </template>
        </ds-table>
    </div>
</template>

<script>
import FieldFilter from '@/components/filters/Filter'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import {strUpp, copy, getLanguages} from '@/utils/utils'
import { flag } from '@/utils/mixins'
import EventBus from "@/store/eventBus";
import VText from "@/components/Text.vue";

export default {
    mixins: [flag],
    data() {
        return {
            btnDisabled: false,
            table: {
                headers: [
                    {name: 'global.Lead', key: 'person', sortKey: 'first_name', value: 'person', display: true},
                    {name: 'global.Country', key: 'country', sortKey: 'country', value: 'country', display: true},
                    {name: 'statistic.Lang', key: 'language', sortKey: 'language', value: 'language', display: true},
                    {name: 'global.Geo', key: 'geo', sortKey: 'geo', value: 'geo', display: true},
                    {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', display: true},
                    {name: 'global.Landing', key: 'landing_name', sortKey: 'landing_name', value: 'landing_name', display: true},
                    {name: 'global.landing_url', key: 'landing_url', sortKey: 'landing_url', value: 'landing', display: true},
                    {name: 'global.Advertiser', key: 'advertiser', sortKey: 'advertiser', value: 'advertiser', display: true},
                    {name: 'global.Affiliate', key: 'affiliate_hash', sortKey: 'affiliate_hash', value: 'affiliate', display: true},
                    {name: 'table.Campaign_ID', key: 'campaign_id', sortKey: 'campaign_id', value: 'campaign_id', display: true},
                    {name: 'statistic.Group_Status', key: 'group_status', sortKey: 'group_status', value: 'group_status', display: true},
                    {name: 'statistic_fields.sub1', key: 'sub1', sortKey: 'sub1', value: 'sub1', display: true},
                    {name: 'statistic_fields.sub2', key: 'sub2', sortKey: 'sub2', value: 'sub2', display: true},
                    {name: 'statistic_fields.sub3', key: 'sub3', sortKey: 'sub3', value: 'sub3', display: true},
                    {name: 'statistic_fields.sub4', key: 'sub4', sortKey: 'sub4', value: 'sub4', display: true},
                    {name: 'statistic_fields.sub5', key: 'sub5', sortKey: 'sub5', value: 'sub5', display: true},
                    {name: 'statistic_fields.sub6', key: 'sub6', sortKey: 'sub6', value: 'sub6', display: true},
                    {name: 'statistic_fields.sub7', key: 'sub7', sortKey: 'sub7', value: 'sub7', display: true},
                    {name: 'statistic_fields.sub8', key: 'sub8', sortKey: 'sub8', value: 'sub8', display: true},
                    {name: 'statistic_fields.sub9', key: 'sub9', sortKey: 'sub9', value: 'sub9', display: true},
                    {name: 'statistic.SYS_Status', key: 'status', sortKey: 'status', value: 'status', display: true},
                    {name: 'statistic.ERR_Status', key: 'advertiser_response', value: 'errorStatus', display: true},
                    {name: 'global.ADV_history', key: 'advertisers_history', sortKey: 'advertisers_history', value: 'a_history', display: true},
                    {name: 'global.ADV_history_response', key: 'advertiser_history_response', sortKey: 'advertiser_history_response', value: 'adv_history_response', display: true},
                    {name: 'modals.Token', key: 'token', value: 'token', display: true},
                    {name: 'global.params_url', key: 'params_url', value: 'params_url', display: true},
                    {name: 'global.Registration_date', key: 'created_at', sortKey: 'created_at', value: 'created_at', display: true},
                    {name: 'global.Send_date', key: 'send_date', sortKey: 'send_date', value: 'send_date', display: true},
                ],
                data: []
            },
            leadData: {
                phone: '',
                email: ''
            },
            leads: [],
            todayCheck: true
        }
    },

    components: {
        VText,
        FieldFilter
    },

    methods: {
        errorStatusInfo(data) {
            EventBus.$emit('emitPopupEvent', {type: 'errorStatusInfo', name: this.$t('global.ADV_history_response'), data: data})
        },

        copy(data) {
            copy(data)

            this.$vs.notify({
                title: 'Success!',
                text: this.$t('notification.success'),
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        },

        getGeoFlag(geo) {
            return getLanguages(geo)
        },

        _date(date) {
            const timeZone = 'Europe/Kiev'
            const d = new Date(date)

            return {
                date() {
                    return d.toLocaleDateString('ru', {timeZone})
                },

                time() {
                    return d.toLocaleTimeString('ru', {timeZone})
                }
            }
        },

        clear() {
            Object.keys(this.leadData).map(key => {
                this.leadData[key] = ''
            })
        },

        checkArray(data) {
            let parseData = data
            if(typeof parseData === 'string') {
                parseData = JSON.parse(data)
            }
            if(Array.isArray(parseData)) {
                return parseData.length ? parseData : false
            }
        },
        checkObject(data) {
            let parseData = data
            if(typeof parseData === 'string') {
                parseData = JSON.parse(data)
            }
            if(typeof parseData === 'object') {
                return Object.keys(parseData).length ? parseData : false
            }
        },
        copyText(text) {
            copy(text)
            this.$vs.notify({
                title: this.$t('global.Copy'),
                text,
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        },

        refreshFilter() {
            this.leadData.phone = ''
            this.leadData.email = ''
            this.leads = []

            this.searchData()
        },

        sysStatus(status) {
            if(status === 'sended') {
                return '#28C76F'
            }
            if(status === 'hold') {
                return '#FF9F43'
            }
            if(status === 'no valid') {
                return '#CCCCCC'
            }
            if(status === 'trash') {
                return '#EA5455'
            }
        },

        strUpp(str) {
            if (str) {
                return strUpp(str)
            } else {
                return '-'
            }
        },

        async searchData() {
            try {
                this.btnDisabled = true

                const data = {
                    phone: this.leadData.phone,
                    email: this.leadData.email,
                    today: this.todayCheck
                }

                Object.keys(data).map(key => {
                    if (data[key] === '' || data[key] === undefined || data[key] === null) {
                        delete data[key]
                    }
                })

                const response = await send('/check', 'POST', {data}).then(data => data.data.result)

                setTimeout(() => {
                    this.table.data = response
                    this.btnDisabled = false
                }, 1000);
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    }
}
</script>

<style lang="scss">
.statusErrorsText {
    max-width: 250px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.testLeads {
    .tableLeads {
        th {
            & > div {
                white-space: nowrap;
            }
        }
    }
    .vs-table--thead {
        tr {
            background: #f8f8f8 !important;
            th {
                white-space: nowrap;
            }
        }
    }

    tr {
        &:nth-child(1n) {
            .name_col {
                cursor: pointer;
                min-width: 200px;
                max-width: 200px;
                padding-right: 2px;

                span {
                    display: inline-block;
                    width: 180px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: relative;
                    z-index: 9;
                    padding: 2px;
                }

                &:hover {
                    span {
                        background-color: #ffffff;
                        width: auto;
                        overflow: initial;
                    }
                }
            }
        }
        .landing__column {
            width: auto;
        }
        .camp-ident {
            color: #bfbfbf;
        }
    }
}
</style>
